import {
    ACCEPT_AGREEMENT_START,
    ACCEPT_AGREEMENT_SUCCESS,
    ACCEPT_AGREEMENT_ERROR,
    REJECT_AGREEMENT_START,
    REJECT_AGREEMENT_SUCCESS,
    REJECT_AGREEMENT_ERROR,
    NEW_AGREEMENT_DATA_RECEIVED,
} from './agreementActionTypes';

import viewStatuses from '../../viewStatus.js';

const initialState = {
    error: false,
    loading: false,
    data: {},
};

export default (state = initialState, action) => {
    switch (action.type) {
        case NEW_AGREEMENT_DATA_RECEIVED:
            return {
                data: {
                    ...state.data,
                    ...action.payload.data,
                },
                loading: false,
                error: false,
            };
        case ACCEPT_AGREEMENT_START:
        case REJECT_AGREEMENT_START:
            return {
                ...state,
                loading: true,
                error: false,
            };
        case ACCEPT_AGREEMENT_SUCCESS:
            return {
                ...state,
                loading: false,
                data: {
                    ...state.data,
                    viewStatus: viewStatuses.AGREEMENT_ACCEPTED,
                },
            };
        case REJECT_AGREEMENT_SUCCESS:
            return {
                ...state,
                loading: false,
                data: {
                    ...state.data,
                    viewStatus: viewStatuses.AGREEMENT_REJECTED,
                },
            };
        case REJECT_AGREEMENT_ERROR:
        case ACCEPT_AGREEMENT_ERROR:
            return {
                ...state,
                loading: false,
                error: true,
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./safeTrade/seller/agreement/agreementReducer.js